/**
 * DOS518 — Integrazione ASTUTO
 * fileAdapter.ts — Import da file XML, CSV o JSON esportato da ASTUTO.
 */

import type { AstutoAdapter } from './baseAdapter';
import type { AstutoResult } from '../types';
import { parseXML } from '../parsers/xmlParser';
import { parseCSV } from '../parsers/csvParser';
import { parseJSON } from '../parsers/jsonParser';

export class FileAdapter implements AstutoAdapter {
  readonly name = 'File ASTUTO (XML / CSV / JSON)';

  async fetch(input?: File | string): Promise<AstutoResult> {
    if (!(input instanceof File)) {
      return { ok: false, error: 'Nessun file selezionato.' };
    }

    const ext = input.name.split('.').pop()?.toLowerCase();
    if (!['xml', 'csv', 'json'].includes(ext ?? '')) {
      return {
        ok: false,
        error: '⚠️ Formato non supportato. Usa file .xml, .csv o .json esportati da ASTUTO.',
      };
    }

    let content: string;
    try {
      content = await input.text();
    } catch {
      return { ok: false, error: 'Impossibile leggere il file.' };
    }

    try {
      const data =
        ext === 'xml'  ? parseXML(content)  :
        ext === 'json' ? parseJSON(content) :
                         parseCSV(content);
      return { ok: true, data };
    } catch (err: any) {
      return {
        ok: false,
        error: `Errore nel parsing del file: ${err?.message ?? 'formato non riconosciuto'}`,
      };
    }
  }
}
